import { render } from "./itemTip.vue?vue&type=template&id=07a52970&scoped=true"
import script from "./itemTip.vue?vue&type=script&lang=js"
export * from "./itemTip.vue?vue&type=script&lang=js"

import "./itemTip.vue?vue&type=style&index=0&id=07a52970&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a52970"]])

export default __exports__